export default __webpack_public_path__ + "static/media/plannen.3e7655d8.jpg";